var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.3986 6.31193C4.3986 7.73415 5.56283 8.89132 7.00023 8.89132C8.43112 8.89132 9.59535 7.73415 9.59535 6.31193C9.59535 4.88324 8.43112 3.72607 7.00023 3.72607C5.56283 3.72607 4.3986 4.88324 4.3986 6.31193ZM10.8246 2.34272C11.9628 3.22191 12.9319 4.50837 13.6278 6.11807C13.6798 6.2409 13.6798 6.38312 13.6278 6.49948C12.2359 9.71888 9.75789 11.6453 7.00016 11.6453H6.99366C4.24244 11.6453 1.76439 9.71888 0.37252 6.49948C0.320488 6.38312 0.320488 6.2409 0.37252 6.11807C1.76439 2.89868 4.24244 0.978676 6.99366 0.978676H7.00016C8.37902 0.978676 9.68634 1.45706 10.8246 2.34272ZM7.00085 7.92003C7.89191 7.92003 8.62037 7.19599 8.62037 6.31033C8.62037 5.41821 7.89191 4.69417 7.00085 4.69417C6.9228 4.69417 6.84476 4.70064 6.77321 4.71356C6.74719 5.42468 6.16183 5.99356 5.43988 5.99356H5.40736C5.38785 6.097 5.37484 6.20043 5.37484 6.31033C5.37484 7.19599 6.10329 7.92003 7.00085 7.92003Z",
    fill: "#999CAD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShow);
export default __webpack_public_path__ + "static/media/Show.e28213ea1a8f7d5a803cfa9fdff9df84.svg";
export { ForwardRef as ReactComponent };